/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import "../App.scss";
import { useDispatch, useSelector } from "react-redux";
import { toggleAuth } from "../Redux/Slices/auth-slice";
import { fetchApi } from "../utlis/axios";
import { useNavigate } from "react-router-dom";
import backArrow from "../assets/back-button.png";
import Lottie from "lottie-react";
import LoginAnimation from "../animation/Login.json";
import Navbar from "../Common/Navbar";
import { toast } from "react-toastify";
import { handleRole } from "../constent/helper";

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { isLogin, userInfo } = useSelector((state) => state?.auth || {});
  const [formValues, setFormValues] = useState({ email: "", password: "" });

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!formValues?.email || !formValues?.password)
      return toast.error("All fields are required!");
    setLoading(true);
    try {
      const result = await fetchApi.post("login/", formValues);
      if (result?.data) {
        dispatch(toggleAuth({ isLogin: true, userInfo: result?.data }));
        setLoading(false);
        handleRole(result?.data?.user?.role, navigate);
      } else {
        setError("Given credentials are wrong");
      }
    } catch (error) {
      setError(
        "An error occurred while trying to log in. Please try again later."
      );
      console.error(error); // Log the error for debugging
      toast.error(error?.response?.data?.detail);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    if (isLogin) handleRole(userInfo?.user?.role, navigate);
  }, [isLogin]);

  return (
    <div className="bg-white">
      <Navbar parent={'login'}/>
      <div
        class="py-8 md:px-16 sm:px-6 px-4 max-w-screen-2xl mx-auto bg-white flex items-center justify-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="md:flex hidden w-1/2 ">
          <div className="auth-sidebar-content mx-auto  ">
            <Lottie
              loop={true}
              animationData={LoginAnimation}
              style={{ width: "500px" }}
              className="auth-sidebar-video"
            />
          </div>
        </div>
        <div className="content md:w-1/2 w-full flex items-center justify-center">
          <div className=" w-full">
            <button
              className="btn2 btn2--tertiary  back-btn backButton"
              style={{ backgroundColor: "white" }}
              onClick={() => navigate("/")}
            >
              <img src={backArrow} alt="back-button" />
            </button>
            <div className="auth-content rounded-xl text-center border bg-[#FCFBF7] flex flex-col items-center sm:py-16 py-6 md:px-8  p-4 mx-auto w-full">
              <h2 className="mt-6">Sign in to KWF</h2>
              <div className="auth-form sign-in-form w-full mb-6">
                <form onSubmit={handleLogin} className="w-full">
                  <div class="form-outline mb-4 w-full items-start">
                    <label
                      className="font-semibold mb-2 text-lg w-full text-start"
                      for="form2Example1"
                    >
                      Email address
                    </label>
                    <input
                      type="email"
                      id="form2Example1"
                      className="form-control login-field border border-[#444444] bg-white"
                      required
                      style={{ borderRadius: "10px", padding: "13px" }}
                      value={formValues?.email}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          email: e?.target?.value,
                        })
                      }
                    />
                  </div>
                  <div class="form-outline mb-4 w-full items-start">
                    <label
                      className="font-semibold mb-2 text-lg w-full text-start"
                      for="form2Example1"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      id="form2Example2"
                      className="form-control login-field"
                      style={{ borderRadius: "10px", padding: "13px" }}
                      required
                      value={formValues?.password}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          password: e?.target?.value,
                        })
                      }
                    />
                  </div>
                  {error && <div className="text-danger">{error}</div>}{" "}
                  {/* Display error message */}
                  <button
                    type="submit"
                    name="login"
                    id="login"
                    className="!w-full primary-button mt-4"
                  >
                    {loading ? "Loading..." : "Sign in"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
